module.exports = __webpack_public_path__ + "img/why-1.3d0406bd.png";